export const tafqeet = (number) => {
    if (number === 0 || isNaN(number)) return 'صفر';
    
    let isNegative = number < 0;
    number = Math.abs(Math.floor(number)); // only handle integers for now, ignoring decimals

    const ones = ["", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", "عشرة", "أحد عشر", "اثنا عشر", "ثلاثة عشر", "أربعة عشر", "خمسة عشر", "ستة عشر", "سبعة عشر", "ثمانية عشر", "تسعة عشر"];
    const tens = ["", "", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"];
    const hundreds = ["", "مائة", "مائتان", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"];

    const getGroupTafqeet = (num) => {
        let text = [];
        const h = Math.floor(num / 100);
        const rem = num % 100;

        if (h > 0) text.push(hundreds[h]);

        if (rem > 0) {
            if (rem < 20) {
                text.push(ones[rem]);
            } else {
                const t = Math.floor(rem / 10);
                const u = rem % 10;
                if (u > 0) {
                    text.push(ones[u] + " و" + tens[t]);
                } else {
                    text.push(tens[t]);
                }
            }
        }
        return text.join(" و");
    };

    let result = [];
    let groupIndex = 0;
    
    let numStr = number.toString();
    while (numStr.length > 0) {
        let groupStr = numStr.slice(-3);
        numStr = numStr.slice(0, -3);
        let groupNum = parseInt(groupStr, 10);

        if (groupNum > 0) {
            let groupText = "";
            let rem100 = groupNum % 100;

            if (groupIndex === 0) {
                groupText = getGroupTafqeet(groupNum);
            } else if (groupIndex === 1) { // Thousands
                if (groupNum === 1) groupText = "ألف";
                else if (groupNum === 2) groupText = "ألفان";
                else if (rem100 >= 3 && rem100 <= 10) groupText = getGroupTafqeet(groupNum) + " آلاف";
                else groupText = getGroupTafqeet(groupNum) + " ألف";
            } else if (groupIndex === 2) { // Millions
                if (groupNum === 1) groupText = "مليون";
                else if (groupNum === 2) groupText = "مليونان";
                else if (rem100 >= 3 && rem100 <= 10) groupText = getGroupTafqeet(groupNum) + " ملايين";
                else groupText = getGroupTafqeet(groupNum) + " مليون";
            } else if (groupIndex === 3) { // Billions
                if (groupNum === 1) groupText = "مليار";
                else if (groupNum === 2) groupText = "ملياران";
                else if (rem100 >= 3 && rem100 <= 10) groupText = getGroupTafqeet(groupNum) + " مليارات";
                else groupText = getGroupTafqeet(groupNum) + " مليار";
            } else if (groupIndex === 4) { // Trillions
                if (groupNum === 1) groupText = "تريليون";
                else if (groupNum === 2) groupText = "تريليونان";
                else if (rem100 >= 3 && rem100 <= 10) groupText = getGroupTafqeet(groupNum) + " تريليونات";
                else groupText = getGroupTafqeet(groupNum) + " تريليون";
            }
            
            result.unshift(groupText);
        }
        groupIndex++;
    }

    return (isNegative ? "سالب " : "") + result.join(" و");
};
